export const tableConst = {
  FAVORITE_PAGE: 'favorite-page',
}
